import {
  IntercepCalibrationActionButton,
  IntercepCalibrationPageBodyContent,
  IntercepCalibrationPageFooter,
} from "pages/IntercepCalibrationPage.styled";

import { TIntercepCalibrationMachineSendActionFn } from "stateMachine/IntercepCalibration";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type IntercepCalibrationMechanicalFoldStepProps = {
  sendAction: TIntercepCalibrationMachineSendActionFn;
};

const IntercepCalibrationMechanicalFoldStep = ({
  sendAction,
}: IntercepCalibrationMechanicalFoldStepProps) => {
  const { t } = useTranslation(["common", "intercep"]);

  return (
    <>
      <IntercepCalibrationPageBodyContent>
        <Typography textAlign="center">
          {t("intercep:calibrationStepActionWithdrawCalibrationStoppers")}
        </Typography>
      </IntercepCalibrationPageBodyContent>

      <IntercepCalibrationPageFooter>
        <IntercepCalibrationActionButton
          variant="contained"
          onClick={() => {
            sendAction({
              type: "MECHANICAL_FOLDED",
            });
          }}
        >
          {t("common:continue")}
        </IntercepCalibrationActionButton>
      </IntercepCalibrationPageFooter>
    </>
  );
};

export default IntercepCalibrationMechanicalFoldStep;
